import styled from 'styled-components';

const TabHolder = styled.div``;

const Heading = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 24px;
  margin-top: 24px;
`;

const StyleRow = styled.div`
  margin: 24px 0 36px 0;
  align-items: center;
  display: flex;
`;

const PillContainer = styled.div`
  margin-left: 6px;
`;

const styledCompanyManagement = {
  StyleRow,
  Heading,
  TabHolder,
  PillContainer,
};

export default styledCompanyManagement;
